import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getSections, completeSection as apiCompleteSection } from '../services/SectionService.ts';

const StudentProgressContext = createContext();

export function StudentProgressProvider({ children }) {
  const [studentSections, setStudentSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchStudentSections = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getSections();
      setStudentSections(data);
      setError('');
    } catch (err) {
      setError(err instanceof Error ? err.message : "An unknown error occurred");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStudentSections();
  }, [fetchStudentSections]);

  const completeSection = useCallback(async (courseType, sectionIndex) => {
    try {
      await apiCompleteSection(courseType, sectionIndex);
      await fetchStudentSections(); // Re-fetch to update the state
    } catch (err) {
      // Handle error if needed
      console.error("Failed to complete section:", err);
    }
  }, [fetchStudentSections]);

  const value = {
    studentSections,
    loading,
    error,
    fetchStudentSections,
    completeSection
  };

  return (
    <StudentProgressContext.Provider value={value}>
      {children}
    </StudentProgressContext.Provider>
  );
}

export function useStudentProgress() {
  const context = useContext(StudentProgressContext);
  if (!context) {
    throw new Error('useStudentProgress must be used within a StudentProgressProvider');
  }
  return context;
}